export const TRIGGER_CHECK = 'TRIGGER_CHECK';
export const SET_IN_PLUGIN_DATA = 'SET_IN_PLUGIN_DATA';
export const INIT_CHILD = 'INIT_CHILD';
export const REMOVE_CHILD = 'REMOVE_CHILD';
export const REMOVE_CHILD_BY_FORCE = 'REMOVE_CHILD_BY_FORCE';
